var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ylContactWay"}},[(_vm.isMobileScreen)?_c('ylContactWayMobile',{attrs:{"list":_vm.list}}):_c('ylContactWayPC',{attrs:{"list":_vm.list}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }